const magazineConfig = {
    magazine: {
        filterLayout: 'MagazineFilterDefaultLayout',
        listLayout: 'MagazineListDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getMagazine',
        getCategoryFunc: 'getMagazineCategory',
        isCategory: true,
        pageRow: 10,
        paginationType: 'pagination',
        listApiParamSet: {
            ip: 1,
            h: 1,
            sa: 1,
        },
        sortOptions: {},
        startSort: {},
        deleteFunc: 'deleteMagazine',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        keyName: 'p_idx'
    },
    createMagazine: {
        getFunc: '',
        detailApiParamSet: {},
        getCategoryFunc: 'getMagazineCategory',
        isCategory: true,
        writeFunc: 'createMagazine',
        writeLayouts: ['MagazineWriteDefaultLayout'],
        writeApiParamSet: {},
        parsingData: {
            p_is_fixed:"p_is_fixed",
            p_type: 'p_type',
            p_display: 'p_display',
            p_reserve_date: 'p_reserve_date',
            category: 'pc_idx',
            hashtag: 'hash',
            p_url: 'p_url',
            title: 'p_title',
            editor: 'editor',
            homeImgShape: 'p_img_shape',
            homeImgColor: 'pb_idx',
            detailText: 'p_detail',
        },
        allSetData: false,
        fileInfo: [
            {fileName: 'mainFile', fileType: 'plan_main', required: true, validatorMsg: '메인이미지를 추가해주세요.',},
            {fileName: 'detailFile', fileType: 'plan_detail', required: false, validatorMsg: '상세이미지를 추가해주세요.',},
            {fileName: 'homeFile', fileType: 'plan_section', required: true, validatorMsg: '홈화면 매거진 이미지를 추가해주세요.',},
            // {fileName: 'brandBannerFile', fileType: 'plan_banner', required: false, validatorMsg: '브랜드 광고 이미지를 추가해주세요.',},
        ],
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {
            100: '이미 고정게시글이 존재합니다.'
        },
        writeFailMsg: '게시글을 등록에 실패하였습니다.',
        fileUploadFailMsg: '파일 등록에 실패하였습니다.',
        deleteFunc: 'deleteMagazine',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        keyName: 'p_idx',
    },
    updateMagazine: {
        getFunc: 'getMagazine',
        detailApiParamSet: {
            ip: 0, h: 1, opfm: 1, opfd: 1, oped: 1, opit: 1,opfs : 1,opfb:1, st: [0, 1, 3]
        },
        getCategoryFunc: 'getMagazineCategory',
        isCategory: true,
        writeFunc: 'updateMagazine',
        writeLayouts: ['MagazineWriteDefaultLayout'],
        writeApiParamSet: {},
        parsingData: {
            p_is_fixed:"p_is_fixed",
            p_type: 'p_type',
            p_display: 'p_display',
            p_reserve_date: 'p_reserve_date',
            category: 'pc_idx',
            hashtag: 'hash',
            p_url: 'p_url',
            title: 'p_title',
            editor: 'editor',
            homeImgShape: 'p_img_shape',
            homeImgColor: 'pb_idx',
            detailText: 'p_detail',

        },
        allSetData: false,
        fileInfo: [
            {fileName: 'mainFile', fileType: 'plan_main', required: true, validatorMsg: '메인이미지를 추가해주세요.',},
            {fileName: 'detailFile', fileType: 'plan_detail', required: false, validatorMsg: '상세이미지를 추가해주세요.',},
            {fileName: 'homeFile', fileType: 'plan_section', required: true, validatorMsg: '홈화면 매거진 이미지를 추가해주세요.',},
            // {fileName: 'brandBannerFile', fileType: 'plan_banner', required: false, validatorMsg: '브랜드 광고 이미지를 추가해주세요.',},
        ],
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {
            100: '이미 고정게시글이 존재합니다.'
        },
        writeFailMsg: '게시글을 수정에 실패하였습니다.',
        fileUploadFailMsg: '파일 등록에 실패하였습니다.',
        deleteFunc: 'deleteMagazine',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        keyName: 'p_idx',
    },
    recommendSelect: {
        filterLayout: 'MagazineFilterDefaultLayout',
        listLayout: 'MagazineListRecommendSelectLayout',
        paginationLayout: 'PaginationRecommendSelectLayout',
        getFunc: 'getMagazine',
        getCategoryFunc: 'getMagazineCategory',
        isCategory: true,
        pageRow: 10,
        paginationType: 'pagination',
        listApiParamSet: {
            ip: 1,
            h: 1,
            sa: 1,
        },
        sortOptions: {},
        startSort: {},
        deleteFunc: 'deleteMagazine',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        keyName: 'p_idx'
    },
    adMagazine: {
        filterLayout: 'MagazineFilterTitleLayout',
        listLayout: 'MagazineListAdLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getAdMagazine',
        getCategoryFunc: '',
        isCategory: false,
        pageRow: 10,
        paginationType: 'pagination',
        listApiParamSet: {
            ip: 1,
        },
        sortOptions: {},
        startSort: {},
        deleteFunc: '',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        keyName: 'am_idx'
    },
    adMagazineCreate: {
        getFunc: '',
        detailApiParamSet: {},
        getCategoryFunc: '',
        isCategory: false,
        writeFunc: 'createAdMagazine',
        writeLayouts: ['MagazineWriteAdLayout'],
        writeApiParamSet: {},
        parsingData: {
            magazineTitle: 'am_title', // 광고 매거진 제목
            magazineNo: 'p_idx', // 매거진 번호
            exposureDateStart: 'am_exposure_sdate', // 노출 기간 시작일
            exposureDateEnd : 'am_exposure_edate',// 노출 기간 종료일
        },
        allSetData: true,
        fileInfo: [],
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {
            '-1': '일치하는 매거진 번호가 없습니다.',
        },
        writeFailMsg: '게시글을 등록할 수 없습니다.',
        fileUploadFailMsg: '파일 등록에 실패하였습니다.',
        deleteFunc: 'deleteAdMagazine',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        keyName: 'am_idx',
    },
    adMagazineUpdate: {
        getFunc: 'getAdMagazine',
        detailApiParamSet: {},
        getCategoryFunc: '',
        isCategory: false,
        writeFunc: 'updateAdMagazine',
        writeLayouts: ['MagazineWriteAdLayout'],
        writeApiParamSet: {},
        parsingData: {
            magazineTitle: 'am_title', // 광고 매거진 제목
            magazineNo: 'p_idx', // 매거진 번호
            exposureDateStart: 'am_exposure_sdate', // 노출 기간 시작일
            exposureDateEnd : 'am_exposure_edate',// 노출 기간 종료일
        },
        allSetData: true,
        fileInfo: [],
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {
            '-1': '일치하는 매거진 번호가 없습니다.',
        },
        writeFailMsg: '게시글을 등록할 수 없습니다.',
        fileUploadFailMsg: '파일 등록에 실패하였습니다.',
        deleteFunc: 'deleteAdMagazine',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        keyName: 'am_idx',
    },
    hash: {
        filterLayout: 'MagazineFilterCreatedLayout',
        listLayout: 'MagazineListHashLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getHash',
        getCategoryFunc: '',
        isCategory: false,
        pageRow: 10,
        paginationType: 'pagination',
        listApiParamSet: {
            ip: 1,
            cnt: 1,
        },
        sortOptions: {},
        startSort: {},
        deleteFunc: 'deleteHash',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {
            '-3': "사용중인 테마 혹은 매거진이 존재합니다."
        },
        keyName: 'ph_idx'
    },
    hashCreate: {
        getFunc: '',
        detailApiParamSet: {},
        getCategoryFunc: '',
        isCategory: false,
        writeFunc: 'createHash',
        writeLayouts: ['MagazineWriteHashLayout'],
        writeApiParamSet: {},
        parsingData: {
            hashTitle: "ph_hash",
        },
        allSetData: false,
        fileInfo: [],
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {},
        writeFailMsg: '게시글을 등록할 수 없습니다.',
        fileUploadFailMsg: '파일 등록에 실패하였습니다.',
        deleteFunc: '',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        keyName: 'ph_idx',
    },
    hashUpdate: {
        getFunc: 'getHash',
        detailApiParamSet: {ip: 0},
        getCategoryFunc: '',
        isCategory: false,
        writeFunc: 'updateHash',
        writeLayouts: ['MagazineWriteHashLayout'],
        writeApiParamSet: {},
        parsingData: {
            hashTitle: "ph_hash",
        },
        allSetData: true,
        fileInfo: [],
        directUrl: '',
        directType: '',
        writeSuccessType: 1,
        writeFailTypes: {},
        writeFailMsg: '게시글을 등록할 수 없습니다.',
        fileUploadFailMsg: '파일 등록에 실패하였습니다.',
        deleteFunc: 'deleteHash',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {
            '-3': "사용중인 테마 혹은 매거진이 존재합니다."
        },
        keyName: 'ph_idx',
    },
    category: {
        filterLayout: 'MagazineFilterCreatedLayout',
        listLayout: 'MagazineListCategoryLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getMagazineCategory',
        getCategoryFunc: '',
        isCategory: false,
        pageRow: 10,
        paginationType: 'pagination',
        listApiParamSet: {
            ip: 1,
            cnt: 1,
        },
        sortOptions: {},
        startSort: {},
        deleteFunc: 'deleteMagazineCategory',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {
            '-2': "권한이 없습니다.",
            '-3': "사용중인 매거진이 존재합니다.",
            '-101': '관리자 비밀번호가 일치하지 않습니다.'
        },
        keyName: 'pc_idx'
    },
    categoryCreate: {
        getFunc: '',
        detailApiParamSet: {},
        getCategoryFunc: '',
        isCategory: false,
        writeFunc: 'createMagazineCategory',
        writeLayouts: ['MagazineWriteCategoryLayout'],
        writeApiParamSet: {},
        parsingData: {
            categoryTitle: "pc_title",
            categorySequence: "pc_seq"
        },
        allSetData: false,
        fileInfo: [
            {fileName: 'mainFile', fileType: 'planCategoryImg', required: true, validatorMsg: '메인이미지를 추가해주세요.',},
        ],
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {},
        writeFailMsg: '등록할 수 없습니다.',
        fileUploadFailMsg: '파일 등록에 실패하였습니다.',
        deleteFunc: '',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        keyName: 'ph_idx',
    },
    categoryUpdate: {
        getFunc: 'getMagazineCategory',
        detailApiParamSet: {ip: 0, opf: 1,},
        getCategoryFunc: '',
        isCategory: false,
        writeFunc: 'updateMagazineCategory',
        writeLayouts: ['MagazineWriteCategoryLayout'],
        writeApiParamSet: {},
        parsingData: {
            categoryTitle: "pc_title",
            categorySequence: "pc_seq"
        },
        allSetData: true,
        fileInfo: [
            {fileName: 'mainFile', fileType: 'planCategoryImg', required: true, validatorMsg: '메인이미지를 추가해주세요.',},
        ],
        directUrl: '',
        directType: '',
        writeSuccessType: 1,
        writeFailTypes: {},
        writeFailMsg: '등록할 수 없습니다.',
        fileUploadFailMsg: '파일 등록에 실패하였습니다.',
        deleteFunc: 'deleteMagazineCategory',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {
            '-2': "권한이 없습니다.",
            '-3': "사용중인 매거진이 존재합니다.",
            '-101': '관리자 비밀번호가 일치하지 않습니다.'
        },
        keyName: 'pc_idx'
    },
    theme: {
        filterLayout: 'MagazineFilterCreatedLayout',
        listLayout: 'MagazineListThemeLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getTheme',
        getCategoryFunc: '',
        isCategory: false,
        pageRow: 10,
        paginationType: 'pagination',
        listApiParamSet: {
            ip: 1,
            cnt: 1,
            h: 1,
        },
        sortOptions: {},
        startSort: {},
        deleteFunc: 'deleteTheme',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {
            '-': "권한이 없습니다.",
            '-3': "사용중인 매거진이 존재합니다.",
        },
        keyName: 'pt_idx'
    },
    themeCreate: {
        getFunc: '',
        detailApiParamSet: {},
        getCategoryFunc: '',
        isCategory: false,
        writeFunc: 'createTheme',
        writeLayouts: ['MagazineWriteThemeLayout'],
        writeApiParamSet: {},
        parsingData: {
            themeTitle: "pt_title",
            themeDisplay: "pt_is_display",
            hashtag: 'hash',
        },
        allSetData: false,
        fileInfo: [
            {fileName: 'mainFile', fileType: 'planThemeImg', required: true, validatorMsg: '메인이미지를 추가해주세요.',},
        ],
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {},
        writeFailMsg: '등록할 수 없습니다.',
        fileUploadFailMsg: '파일 등록에 실패하였습니다.',
        deleteFunc: '',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        keyName: 'pt_idx',
    },
    themeUpdate: {
        getFunc: 'getTheme',
        detailApiParamSet: {ip: 0, opf: 1, h: 1},
        getCategoryFunc: '',
        isCategory: false,
        writeFunc: 'updateTheme',
        writeLayouts: ['MagazineWriteThemeLayout'],
        writeApiParamSet: {},
        parsingData: {
            themeTitle: "pt_title",
            themeDisplay: "pt_is_display",
            hashtag: 'hash',
        },
        allSetData: true,
        fileInfo: [
            {fileName: 'mainFile', fileType: 'planThemeImg', required: true, validatorMsg: '메인이미지를 추가해주세요.',},
        ],
        directUrl: '',
        directType: '',
        writeSuccessType: 1,
        writeFailTypes: {},
        writeFailMsg: '등록할 수 없습니다.',
        fileUploadFailMsg: '파일 등록에 실패하였습니다.',
        deleteFunc: 'deleteTheme',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {
            '-': "권한이 없습니다.",
            '-3': "사용중인 매거진이 존재합니다.",
        },
        keyName: 'pt_idx'
    },
}

export default {
    methods: {
        returnMagazineConfig(type) {
            return magazineConfig[type];
        },
    },
    filterConfig: {
        ti: { //제목
            type: 'query',
            classname: 'searchInput'
        },
        cr: { //작성일
            type: 'between',
            classname: 'filterDate'
        },
        pd: { //노출여부
            type: 'match',
            classname: 'filterDisplay',
            option: {
                book: {
                    res: 1,
                }
            },
        },
        ca: { //카테고리
            type: 'match',
            classname: 'filterCategory'
        },
        ha: { //해시태그
            type: 'terms',
            classname: 'filterHash'
        }
    },
}
